import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ApiService } from '.././api.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { TypeAccountPipe } from '../type-account.pipe';
import { SamedatePipe } from '../samedate.pipe';
@Component({
  selector: 'app-dailyrestrictions',
  templateUrl: './dailyrestrictions.component.html',
  styleUrls: ['./dailyrestrictions.component.scss']
})
export class DailyrestrictionsComponent implements OnInit {

  arre: any;
  show = false;
  add: any = false;
  update: any = false;
  delete: any = false;
  name: any;
  email: any;
  password: any;
  adress: any;
  root: any = undefined;
  phone: any;
  control: any = undefined;
  idDU: any;
  rootA: any;
  controlA: any;
  nameU: any;
  emailU: any;
  passwordU: any;
  adressU: any;
  rootU: any;
  phoneU: any;
  controlU: any;
  idUp: any;
  searchName: any;
  rootSearch = 'undefined';
  controlSearch = 'Search By Permission';
  type: any = 'Type';
  notes: any;
  OrderDate000S: any = true;
  OrderDate000S0: any = false;
  OrderDate000SS: any = true;
  OrderDate000SS0: any = false;
  dateFrom: any = 'All';
  dateTo: any;
  arrayAll: any;
  dateAttend: any = 'All';
  dateAttend01New: any = 'All';
  arrRoot: any;
  arrRootSub: any;
  idLevel2 = 16;
  Notes: any;
  The_Amount: any;
  NotesUpdate: any;
  The_AmountUpdate: any;
  Exchange_Rate: any;
  Account_Name_search: any;
  Account_Name_searchUpdate: any;
  date: any = new Date().toJSON().slice(0,10);
  PaymentWay: any;
  dateUpdate: any;
  PaymentWayUpdate: any;
  totalMoney: any;

  constructor(private _ApiService: ApiService , private _Router: Router, private _AppComponent: AppComponent , private _TypeAccountPipe: TypeAccountPipe , private _SamedatePipe: SamedatePipe ) {
    this._AppComponent.activeU = '';
    this._AppComponent.activeR = '';
    this._AppComponent.activeS = '';
    this._AppComponent.activeI = '';
    this._AppComponent.activeC = '';
    this._AppComponent.activeP = '';
    this._AppComponent.activeCu = '';
    this._AppComponent.activeCR = '';
    this._AppComponent.activeH = '';
    this._AppComponent.activeO = '';
    this._AppComponent.activeCE = '';
    this._AppComponent.activeCV = '';
    this._AppComponent.activeSE = '';
    this._AppComponent.activeSEB = '';
    this._AppComponent.activeCuO = '';
    this._AppComponent.activeCuOStore = '';
    this._AppComponent.activeHRE = '';
    this._AppComponent.activeHReport = '';
    this._AppComponent.activeCVV = '';
    this._AppComponent.activeCVEm = '';
    this._AppComponent.activeCVEmAttendances = '';
    this._AppComponent.activeCVEmAttendancesSalary = '';
    this._AppComponent.activeCVEmPermession = ''
    this._AppComponent.activeHReportAccounts = '';
    this._AppComponent.activeHReportCashPayments = '';
    this._AppComponent.activeCashReceipts = '';
    this._AppComponent.activeDailyRestrictions = 'active';
    this._AppComponent.activeGeneralReports = '';
    this._AppComponent.activeHReportPrivate = '';
    this._AppComponent.activeHReportPrivatePaymentsReport = '';
    this._ApiService.allCaAccountCheck().subscribe((res)=>{
      this.arrRoot = res;
      this.ngOnInit();
      $('.loading').css({display: 'none'});
    })
    this._ApiService.allCaAccountCheckSub().subscribe((res)=>{
      this.arrRootSub = res;
      this.ngOnInit();
    })
    this._ApiService.getItemBookedDaily({date: this.date}).subscribe((res)=>{
      this.totalMoney = 0;
      this.rootA = res;
      var x = this._TypeAccountPipe.transform(this.rootA , "All")
      var e = this._SamedatePipe.transform(x , this.dateAttend , this.dateAttend01New);
      e.forEach((element: any) => {
                this.totalMoney = this.totalMoney + element.money
              })
              if(this.totalMoney == '' || this.totalMoney == null || this.totalMoney == undefined || this.totalMoney == 0){

              } else {
              var xx = parseInt(this.totalMoney);
              var yy = xx.toLocaleString()
              var b = yy.toString()
              this.totalMoney = b;
              }
      this.ngOnInit();
      $('.loading').css({display: 'none'});
    })

    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        res.data.forEach((element: any) => {
          if(element.name == 'CashPayments') {
            if(element.	add_permission === 1) {
              this.add = true;
            }
            if(element.	update_permission === 1) {
              this.update = true;
            }
            if(element.	delete_permission === 1) {
              this.delete = true;
            }
          }

        });
        this._AppComponent.refreshNotification()
        this.show = true;
      } else {
        this._Router.navigate([''])
        this.show = false;
      }
    })
    this._AppComponent.goProfile();

   }
   goFilter() {
    $('.loading').css({display: 'block'});
    this._ApiService.getItemBookedDaily({date: this.date}).subscribe((res)=>{
      this.totalMoney = 0;
      this.rootA = res;
      var x = this._TypeAccountPipe.transform(this.rootA , "All")
      var e = this._SamedatePipe.transform(x , this.dateAttend , this.dateAttend01New);
      e.forEach((element: any) => {
                this.totalMoney = this.totalMoney + element.money
              })
              if(this.totalMoney == '' || this.totalMoney == null || this.totalMoney == undefined || this.totalMoney == 0){

              } else {
              var xx = parseInt(this.totalMoney);
              var yy = xx.toLocaleString()
              var b = yy.toString()
              this.totalMoney = b;
              }
      this.ngOnInit();
      $('.loading').css({display: 'none'});
    })

   }
   goDate() {
    this.dateTo = $('#toDG').val();
    this.dateFrom = $('#fromDG').val();
    // $('.loading').css({display: 'block'});
    // this._ApiService.allID({from: $('#fromDG').val(), to: $('#toDG').val()}).subscribe((res)=>{
    //   if(res.check === true){
    //     this.arre = res.data;
    //     $('.loading').css({display: 'none'});
    //   } else{
    //     alert('error')
    //     $('.loading').css({display: 'none'});

    //   }
    // })
  }
   closeUp(){
    this.idUp = '';
    this.NotesUpdate = '';
    this.The_AmountUpdate = '';
    this.PaymentWayUpdate = '';
    this.type = 'Type';
    $('.Account_NameUpdate').val('Account_Name').trigger('change.select2');
    $('.Sub_AccountUpdate').val('Sub_Account').trigger('change.select2');
    $('#upd-up').css({display: 'none'});
  }
  upP(data: any){
    console.log(new Date(data.date).toISOString().replace(/T/, ' ').split(' ')[0])

    this.dateUpdate = new Date(data.date);
    this.dateUpdate = this.dateUpdate.setDate(this.dateUpdate.getDate() + 1)
    this.dateUpdate = new Date(this.dateUpdate).toJSON().slice(0,10);
    this.idUp = data.id;
    this.NotesUpdate = data.notes;
    this.The_AmountUpdate = data.money;
    this.type = data.type;
    this.PaymentWayUpdate = data.waypay;
    $('.Account_NameUpdate').val(data.Account_Name).trigger('change.select2');
    this.Account_Name_searchUpdate = $('.Account_NameUpdate').val();
    setTimeout(() => {
      $('.Sub_AccountUpdate').val(data.Sub_Account).trigger('change.select2');
    }, 100);
    $('#upd-up').css({display: 'block'});
      }
  okUp(data: any){
    if(this.type == undefined || this.type == '' || this.type == null || this.type == 'Type'){
      alert('Plz Put The Type')
    } else {
      data.id = this.idUp;
    data.Account_Name = $('.Account_NameUpdate').val();
    data.Sub_Account = $('.Sub_AccountUpdate').val();
    data.PaymentWay = null;
    $('.loading').css({display: 'block'});
    this._ApiService.updateUserCashPaymentsDaily(data).subscribe((res)=> {
      if(res === true) {
        this._ApiService.getItemBookedDaily({date: this.date}).subscribe((res)=>{
          this.totalMoney = 0;
          this.rootA = res;
          var x = this._TypeAccountPipe.transform(this.rootA , "All")
          var e = this._SamedatePipe.transform(x , this.dateAttend , this.dateAttend01New);
          e.forEach((element: any) => {
            this.totalMoney = this.totalMoney + element.money
          })
          this.closeUp();
          $('.loading').css({display: 'none'});
        })
      } else {
        alert("Updated Don't Successfully");
        // this.closeUp();
        $('.loading').css({display: 'none'});
      }
    })
    }
  }
   delU(id: any){
    $('#upd-dd').css({display: 'block'});
    this.idDU = id;
  }
  closedd(){
    $('#upd-dd').css({display: 'none'});
    this.idDU = '';
  }
  ok(){
    $('.loading').css({display: 'block'});
    var x = this.idDU;
    this._ApiService.delUAttendPay({id: x}).subscribe((res)=>{
      if(res === true){
        this.rootA.forEach((element: any , index: any) => {
          if(element.id == x) {
            this._ApiService.getItemBookedDaily({date: this.date}).subscribe((res)=>{
              this.totalMoney = 0;
              this.rootA = res;
              var x = this._TypeAccountPipe.transform(this.rootA , "All")
              var e = this._SamedatePipe.transform(x , this.dateAttend , this.dateAttend01New);
              e.forEach((element: any) => {
                this.totalMoney = this.totalMoney + element.money
              })
              if(this.totalMoney == '' || this.totalMoney == null || this.totalMoney == undefined || this.totalMoney == 0){

              } else {
              var xx = parseInt(this.totalMoney);
              var yy = xx.toLocaleString()
              var b = yy.toString()
              this.totalMoney = b;
              }
              this.closedd();
              $('.loading').css({display: 'none'});
            })
          }
        });
  } else {
    alert('Deleted Not Successfully\nPlease, if you want to delete this , you must return Money No Delete');
    this.closedd();
    $('.loading').css({display: 'none'});
  }
})
  }
  addUser(){
    $('#upd').css({display: 'block'});
  }
  close(){
    $('#upd').css({display: 'none'});
    $(`.Account_Name`).val('undefined').trigger('change.select2');
    $(`.Sub_Account`).val('undefined').trigger('change.select2');
    // $('.rootSelect000').val('undefined').trigger('change.select2');
    this.Notes = '';
    this.type = 'Type';
    this.PaymentWay = null;
    this.The_Amount = '';
    // this.date = new Date().toJSON().slice(0,10);
  }
  addUser0(data: any){
    data.PaymentWay = null;
    if($(`.Account_Name`).val() ==  '' || $(`.Account_Name`).val() == 'undefined' || $(`.Account_Name`).val() == null || $(`.Account_Name`).val() == undefined || $(`.rootSelect000`).val() ==  '' || $(`.rootSelect000`).val() == 'undefined' || $(`.rootSelect000`).val() == null || $(`.rootSelect000`).val() == undefined || data.The_Amount == '' || data.The_Amount == undefined || this.type == undefined || this.type == '' || this.type == null || this.type == 'Type') {
      alert('Plz Put Data');
    } else {
      data.Account_Name = $('.Account_Name').val();
      data.Sub_Account = $('.Sub_Account').val();
      data.Treasury = $('.rootSelect000').val();
      data.PaymentWay = null;
      $('.loading').css({display: 'block'});
    this._ApiService.addPay00(data).subscribe((res)=>{
      if(res.check === true){
            this._ApiService.getItemBookedDaily({date: this.date}).subscribe((res)=>{
              this.totalMoney = 0;
              this.rootA = res;
              var x = this._TypeAccountPipe.transform(this.rootA , "All")
              var e = this._SamedatePipe.transform(x , this.dateAttend , this.dateAttend01New);
              e.forEach((element: any) => {
                this.totalMoney = this.totalMoney + element.money
              })
              if(this.totalMoney == '' || this.totalMoney == null || this.totalMoney == undefined || this.totalMoney == 0){

              } else {
              var xx = parseInt(this.totalMoney);
              var yy = xx.toLocaleString()
              var b = yy.toString()
              this.totalMoney = b;
              }
              $('.loading').css({display: 'none'});
              this.close();
            })
      } else {
        alert('Did not work');
        this.close();
        $('.loading').css({display: 'none'});
      }
    })
    // }
  }
  }
  printert(){
    window.print();
  }
  OrderDate0010S() {
    this.OrderDate000S = false;
    this.OrderDate000S0 = true;
    setTimeout(() => {
      $('.fromDA').val(new Date().toJSON().slice(0,10))
    }, 100);

  }
  OrderDate0010SS(){
    this.OrderDate000SS = false;
    this.OrderDate000SS0 = true;
    setTimeout(() => {
      $('.toDA').val(new Date().toJSON().slice(0,10));
    }, 100);
  }
  totalmoney() {
    this.totalMoney = 0;
    var x = this._TypeAccountPipe.transform(this.rootA , "All")
              var e = this._SamedatePipe.transform(x , this.dateAttend , this.dateAttend01New);
              e.forEach((element: any) => {
                this.totalMoney = this.totalMoney + element.money
              })
              if(this.totalMoney == '' || this.totalMoney == null || this.totalMoney == undefined || this.totalMoney == 0){

              } else {
              var xx = parseInt(this.totalMoney);
              var yy = xx.toLocaleString()
              var b = yy.toString()
              this.totalMoney = b;
              }
  }
  ngOnInit(): void {
    var self = this;
    setTimeout(() => {
      $('.Account_Name').on('select2:select', function (e: any) {
        self.Account_Name_search = $('.Account_Name').val();
      })
      $('.Account_NameUpdate').on('select2:select', function (e: any) {
        self.Account_Name_searchUpdate = $('.Account_NameUpdate').val();
      })
      $('.select2, .js-example-basic-multiple').select2();
    }, 500);
  }

}
